import React, { useEffect, useState } from 'react';
import apiService from '../../../Auth/apiService';
import { useAuth } from '../../../Auth/AuthContext';
import Table from 'react-bootstrap/Table';

const SeguimientoCambioUbicacion = ({ idPersona }) => {
  const { token, user } = useAuth();
  const [datos, setDatos] = useState([]);
  useEffect(() => {
    fetchData();
    }, []);
  const fetchData = async () => {
    const url = '/caracterizacion/seguimientocambioubicacion/consultar';
    const obj = {
        usrId: user.id,
        str_idpersona: idPersona,
    };
    await apiService.post(url, obj, token)
    .then(response => {
        setDatos(response.data);
    })
    .catch(error => {
    
    })
  }
  

  return (
    <div className="seguimiento-cambio-ubicacion">
      <h2>Seguimiento Cambio Ubicación</h2>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Barrio</th>
            <th>Dirección</th>
            <th>ID Persona</th>
            <th>Celular</th>
            <th>Fecha Registro</th>
            <th>ID Usuario</th>
          </tr>
        </thead>
        <tbody>
          {datos.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.intIdbarrio}</td>
              <td>{item.strDireccion}</td>
              <td>{item.strIdpersona}</td>
              <td>{item.strCelular}</td>
              <td>{item.segFecharegistro}</td>
              <td>{item.intIdusuario}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SeguimientoCambioUbicacion;
